import * as moment from 'moment';
import { SCHEDULE_DEFAULT_COLOR, SCHEDULE_DEFAULT_REPETITION, SCHEDULE_DEFAULT_TIMEZONE } from '../conf/schedule';

export class Schedule {
    Id: number;
    Name: string;
    Description: string;
    UserId?: number;
    SceneryId: number;
    Start: string;
    End: string;
    Tz: string;
    Hours: number;
    Minutes: number;
    EveryKey: string;
    EveryValue: number;
    WeekDays?: string;
    MonthDay?: number;
    CalendarId?: number;
    Color: string;

    constructor() {
        this.Name = '';
        this.Description = '';
        this.Hours = 12;
        this.Minutes = 0;
        const startMoment = moment().add(1, 'days');
        const endMoment = moment().add(7, 'days');
        this.Start = startMoment.toISOString();
        this.End = endMoment.toISOString();
        this.WeekDays = '';
        this.MonthDay = startMoment.date();
        this.EveryKey = SCHEDULE_DEFAULT_REPETITION.Value;
        this.EveryValue = 1;
        this.Tz = SCHEDULE_DEFAULT_TIMEZONE;
        this.Color = SCHEDULE_DEFAULT_COLOR;
    }
}
